import * as React from "react";
import { Grid, Typography, IconButton, Button } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from "react-router";



export const InvalidSelectionNewGlobalForm = (propData: any) => {
    const navigate = useNavigate();
    return (
        <Grid container style={{ backgroundColor: "#ffc107", display: "flex", alignItems: "center", padding: "1em", borderBottom: "5px solid black", borderRadius: "10px", margin: "1em 0" }} >
            <Grid container style={{ margin: "0 1em", borderBottom: "2px solid #FAD5A5" }}>

                <Grid item xs={10} style={{ textAlign: "start", display: "flex", alignItems: "center" }}>
                    <ReportProblemIcon fontSize="large" />
                    <Typography variant="h4" style={{ paddingLeft: "1em" }} >
                        Invalid Selection
                    </Typography>
                </Grid>
                <Grid item xs={2} style={{ textAlign: "right" }}>
                    <IconButton aria-label="cancel" size="large" onClick={propData.closePopup} >
                        <CancelSharpIcon fontSize="large" />
                    </IconButton>
                </Grid>
            </Grid>

            <Grid container style={{ margin: "1em " }} >
                <Grid item xs={12}>
                    <Typography variant="h6" style={{ marginBottom: "0.5em" }}>
                        Appraisal for the selected fund is still in progress. You cannot create a new one.Click on button to view existing appraisal for the fund.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Button sx={{textTransform:"none"}} variant="contained" style={{ backgroundColor: "#00ad97" }} startIcon={<InfoIcon />} onClick={() => navigate(`/global/global-equity/view/${propData.appraisalId}`)} >
                        View Appraisal
                    </Button>
                </Grid>
            </Grid>

        </Grid>
    )
}